import { unsubscribe } from '@services/push-notification.service';
import { AppDispatch } from '@/state';
import { UserType } from '@/state/interface';
import { fetchUserInfo } from '@/state/slice/userSlice';
import { IPublicClientApplication } from '@azure/msal-browser';
import { post } from '@services/api.service';
import { BIZ_BASE_URL } from '@constants/api.constants';
import { logError, logEvent } from '@/AppInsights';
import { persistor } from '@/state';

const endpoint = BIZ_BASE_URL;

export const getCurrentUser = async (instance: IPublicClientApplication, dispatch: AppDispatch) => {
	try {
		const account = instance.getActiveAccount();
		const userType = account?.idTokenClaims?.extension_entity_type as UserType;
		const id = account?.idTokenClaims?.extension_entity_id as string;
		dispatch(fetchUserInfo({ userType, id }));
		return id;
	} catch (error) {
		console.error('Error fetching data:', error);
	}
};

export const clearReduxStorage = async () => {
	try {
		await persistor.purge();
	} catch (error) {
		logError(new Error(`Failed to clear Redux storage: ${error}`));
	}
};

export const handleLogout = async (uid: string, instance: IPublicClientApplication) => {
	await unsubscribe(uid);
	await clearReduxStorage();
	msalLogout(instance);
};

export const msalLogout = (instance: IPublicClientApplication) => {
	logEvent('msalLogout_called');
	post(`${endpoint}/b2c/logout`, null).finally(() => {
		if (!instance) {
			logError(new Error('MSAL logout redirect failed: msalInstance is null or undefined.'));
			return;
		}
		const activeAccount = instance.getActiveAccount() ?? undefined;
		if (!activeAccount) {
			logError(new Error(`MSAL no active account: ${activeAccount} `));
		}
		try {
			void instance.logoutRedirect({
				account: instance.getActiveAccount(),
				onRedirectNavigate: () => {},
			});
		} catch (error) {
			logError(new Error(`MSAL logout redirect failed: ${error}`));
		}
	});
};
